import { useState, useEffect } from 'react';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

let timeout = null;

export default function useGetTourLogs() {
  const [logs, setLogs] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  const [filters, setFilters] = useState({
    limit: 16,
    offset: 0,
    query: '',
    status: '',
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    if (isFetched || filters?.query?.length) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        getTourLogs();
      }, 500);
    }
  }, [filters]);

  useEffect(() => {
    getTourLogs();
  }, []);

  const updateFilter = (key, value) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters, [key]: value };
      if (key !== 'offset') {
        newFilters.offset = 0;
      }
      return newFilters;
    });
  };

  const getTourLogs = async () => {
    try {
      setIsLoading(true);

      const { ...restFilters } = filters;
      const params = {
        ...restFilters,
      };

      const url = buildUrlWithParams(
          `/tours/tours-logs`,
          params
        );

      const response = await fleetApi.get(url);

      if (isFetched) {
        await new Promise((resolve) => setTimeout(resolve, 150));
      }

      if (response.status === 200) {
        setLogs((prevData) => ({
          ...response.data,
          items:
            prevData && filters.offset !== 0
              ? [...prevData.items, ...response.data.items]
              : response.data.items,
        }));
      } else {
        throw new Error('Failed to fetch tour details');
      }
    } catch (error) {
      setError(error?.message || 'Une erreur est survenue.');
    } finally {
      setIsLoading(false);
      setIsFetched(true);
    }
  };

  const fetchNextPage = () => {
    updateFilter('offset', filters.offset + filters.limit);
  };

  return {
    logs,
    error,
    isLoading,
    isFirstLoading: isLoading && !isFetched,
    refetch: getTourLogs,
    fetchNextPage,
    hasMore: logs
      ? filters.offset + filters.limit < logs.pagination_info.total_items
      : true,
    filters,
    getTourLogs,
    updateFilter
  };
}
